import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

/**
 * Get product bundles list.
 * GET /api/v1/product-bundles
 */
export const getProductBundles = (params?: Record<string, any>) => {
  return new Promise((resolve, reject) => {
    let url = `${BASE_URL}/api/v1/product-bundles`;
    if (params && Object.keys(params).length > 0) {
      const query = new URLSearchParams();
      for (const key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          query.set(key, params[key]);
        }
      }
      const qs = query.toString();
      if (qs) url += `?${qs}`;
    }
    api
      .get(url)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

/**
 * Get product bundle by ID (for edit).
 * GET /api/v1/product-bundles/:id
 */
export const getProductBundleById = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/product-bundles/${id}`)
      .then((res) => resolve(res.data?.data ?? res.data))
      .catch((err) => reject(err));
  });
};

/**
 * Save (create) a product bundle.
 * POST /api/v1/product-bundles
 */
export const saveProductBundle = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/product-bundles`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

/**
 * Update a product bundle.
 * PUT /api/v1/product-bundles/:id
 */
export const updateProductBundle = (id: number, payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/product-bundles/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
